import { render, staticRenderFns } from "./onboardingComplete.vue?vue&type=template&id=f1b07482&scoped=true&"
import script from "./onboardingComplete.vue?vue&type=script&lang=js&"
export * from "./onboardingComplete.vue?vue&type=script&lang=js&"
import style0 from "./onboardingComplete.vue?vue&type=style&index=0&id=f1b07482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b07482",
  null
  
)

export default component.exports